export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/muze-bg.png?a30d6d596e75337df8c462fcae4dde10";